export const MODAL_ID = "create-job-from-lead";
